import { PROFILE } from "../actions/actionsTypes";
import { IGlobal } from "../models/global.interface";
import { IActionBase } from "../models/root.interface";

const initialState: any = {
    profileDetails: null,
    updateProfile: null,
    isSellingPriceData: true,
    supportApiDetails: null,
    getDocumentExpiryStatusData: null,
    getDocumentAccessKamListData: null
};


function profileReducer(state: any = initialState, action: IActionBase): IGlobal {
    switch (action.type) {
        case PROFILE.GET_PROFILE_FETCHING:
            return {
                ...state,
                profileDetails: { loading: true, data: null, err: null }
            };
        case PROFILE.GET_PROFILE_SUCCESS:
            return {
                ...state,
                profileDetails: { loading: false, data: action.payload.data, err: null }
            };
        case PROFILE.GET_PROFILE_ERROR:
            return {
                ...state,
                profileDetails: { loading: false, data: null, err: action.payload }
            };
        case PROFILE.PUT_PROFILE_FETCHING:
            return {
                ...state,
                updateProfile: { loading: true, data: null, err: null }
            };
        case PROFILE.PUT_PROFILE_SUCCESS:
            return {
                ...state,
                updateProfile: { loading: false, data: action.payload.data, err: null }
            };
        case PROFILE.PUT_PROFILE_ERROR:
            return {
                ...state,
                updateProfile: { loading: false, data: null, err: action.payload }
            };

        case PROFILE.POST_SUPPORT_FETCHING:
            return {
                ...state,
                supportApiDetails: { loading: true, data: null, err: null }
            };
        case PROFILE.POST_SUPPORT_SUCCESS:
            return {
                ...state,
                supportApiDetails: { loading: false, data: action.payload.data, err: null }
            };
        case PROFILE.POST_SUPPORT_ERROR:
            return {
                ...state,
                supportApiDetails: { loading: false, data: null, err: action.payload }
            };

        case PROFILE.GET_DOCUMENT_EXPIRY_FETCHING:
            return {
                ...state,
                getDocumentExpiryStatusData: { loading: true, data: null, err: null }
            };
        case PROFILE.GET_DOCUMENT_EXPIRY_SUCCESS:
            return {
                ...state,
                getDocumentExpiryStatusData: { loading: false, data: action.payload.data, err: null }
            };
        case PROFILE.GET_DOCUMENT_EXPIRY_ERROR:
            return {
                ...state,
                getDocumentExpiryStatusData: { loading: false, data: null, err: action.payload }
            };

        case PROFILE.GET_DOCUMENT_ACCESS_KAM_LIST_FETCHING:
            return {
                ...state,
                getDocumentAccessKamListData: { loading: true, data: null, err: null }
            };
        case PROFILE.GET_DOCUMENT_ACCESS_KAM_LIST_SUCCESS:
            return {
                ...state,
                getDocumentAccessKamListData: { loading: false, data: action.payload.data, err: null }
            };
        case PROFILE.GET_DOCUMENT_ACCESS_KAM_LIST_ERROR:
            return {
                ...state,
                getDocumentAccessKamListData: { loading: false, data: null, err: action.payload }
            };

        case PROFILE.IS_SELLING_PRICE_TOGGLE_BUTTON:
            return {
                ...state,
                isSellingPriceData: action.payload.data,
            }
        case PROFILE.GET_PROFILE_PLACED_PROFILE_FETCHING:
            return {
                ...state,
                profilePlacedSummary: { loading: true, data: null, err: null }
            }
        case PROFILE.GET_PROFILE_PLACED_PROFILE_SUCCESS:
            return {
                ...state,
                profilePlacedSummary: { loading: true, data: action.payload.data, err: null }
            }
        case PROFILE.GET_PROFILE_PLACED_PROFILE_ERROR:
            return {
                ...state,
                profilePlacedSummary: { loading: true, data: null, err: action.payload }
            }
        default:
            return state;
    }
};
export default profileReducer;